import { DownloadOutlined, PrinterOutlined, ReloadOutlined } from '@ant-design/icons';
import moment, { Moment } from 'moment';
import * as React from 'react';
import { HocOptions } from '../common/generic-hoc.types';
import { ConsignmentCategory, NextOrPrev, Pagination } from '../../library/Types';
import { StylesProps, ThemeType } from '../../theme/jss-types';
import { Master, ExcelColumn } from '../../types/master-data-types';
import Paginator from '../common/paginator';
import { excelColumns, csvRequestType } from './consignments.constants';
import {
    DatePicker, message, Menu, Dropdown, Button, Tooltip,
} from 'antd';
import {
    getExcels,
    printExcelA4,
} from '../../network/excel-upload';
import GenericHoc from '../common/generic-hoc';
import authHelper from '../../auth/auth-helper';
import { BUSINESS_BOOKING_API_URL } from '../../library/globals';
import {
    EXCEL_DOWNLOAD,
    EXCEL_DOWNLOAD_ERRORS,
    EXCEL_PENDING,
} from '../../network/api.constants';
import { useTranslation } from 'react-i18next';
import { getPrintHistoryRoute } from 'routing/routing-helper';
import { useHistory } from 'react-router-dom';
import FixedHeaderTable from 'components/common/FixedHeaderTable/FixedHeaderTable';
/* eslint-disable max-len */
import { get } from 'lodash';
import Helper from '../../library/Helper';
import { getCNUploadRequests, getAsyncRequestsData } from '../../network/common.api';
import { printBulkLabelWithPx } from '../../network/consignments.api';

const menuStyle: React.CSSProperties = {
    padding: 12,
    borderBottom: '1px solid #CCCCCC',
    fontWeight: 'bold',
    fontSize: 12,
};
const styles = (theme: ThemeType) => ({
    main: {
        width: '100%',
        padding: '5px 6px 6px 3px',
        height: '100%',
    },
    filters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        marginBottom: 4,
        flexDirection: 'row',
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 28,
            borderRadius: 3,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor} `,
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
        },
        '& .ant-dropdown-menu-submenu-title': {
            padding: '12px 4px',
        },
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
            height: 28,
        },
        '& .ant-select-selector': {
            borderRadius: '4px 0 0 4px !important',
        },
        '& .ant-input': {
            borderLeft: 'none !important',
            borderRadius: '0 4px 4px 0 !important',
        },
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: 20,
    },
    dateRange: {
        '& .ant-picker-cell-in-view::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-cell:hover .ant-picker-cell-in-view:hover::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-panel-container': {
            backgroundColor: '#f7f7f7 !important',
            borderRadius: '4px !important',
            display: 'flex !important',
            flexDirection: 'row-reverse !important',
        },
        '& .ant-picker-cell-in-view .ant-picker-cell-inner': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            width: '32px !important',
            height: '32px !important',
            padding: '0 !important',
            backgroundColor: 'white !important',
            borderRadius: '4px !important',
            margin: '1px !important',
            boxSizing: 'border-box !important',
            '&:hover': {
                backgroundColor: '#b9e0ff !important',
            },
        },
        '& .ant-picker-cell-in-view': {
            padding: '0 !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.secondaryFillColor} !important`,
            borderColor: `${theme.secondaryFillColor} !important`,
            fontWeight: 'bold !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-disabled::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-footer': {
            minWidth: 140,
            padding: 4,
        },
        '& .ant-picker-ranges .ant-picker-preset > .ant-tag-blue': {
            color: 'black',
            background: 'transparent !important',
            borderColor: 'transparent !important',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
        },
        '& .ant-picker-ranges > li:hover': {
            display: 'inline-block',
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            borderRadius: '4px',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
        },
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    dateFilter: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        '& .ant-picker': {
            borderRadius: '6px',
            width: 215,
            height: 32,
        },
        '& .ant-picker-input > input': {
            fontSize: '13px',
        },
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0,
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    table: {
        '& .ant-table table': {
            backgroundColor: '#FFF',
        },
    },
    filterText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        marginRight: 8,
    },
});

interface ExcelUploadProps extends StylesProps<ReturnType<typeof styles>> {
    uiTheme: ThemeType;
    master: Master;
}

const ExcelUpload = (props: ExcelUploadProps) => {
    const {
        classes, uiTheme, master,
    } = props;
    const history = useHistory();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [excels, setExcels] = React.useState<any>([]);
    const [dates, setDates] = React.useState({
        startDate: moment().subtract(1, 'M'),
        endDate: moment(),
    });
    const { t } = useTranslation();
    const [pagination, setPagination] = React.useState<Pagination>({
        nextOrPrev: 'first',
        currentPageNumber: 1,
        resultPerPage: 20,
        isNextPresent: false,
        lastUpdatedAt: null,
    });
    const [toggle, setToggle] = React.useState<boolean>(true);

    const softdataCreationUnifiedFlow = master?.parts_to_show?.softdata_creation_unified_flow_enabled;
    const enable_customer_config = master?.parts_to_show?.enable_customer_config || false;
    const customerProperties = master?.properties;
    let showShipmentLabelA4 = true;
    let showShippingLabelA6 = true;
    let showAddressLabelA4 = true;
    let showAddressLabel4X2 = true;
    let useThirdPartyLabel = false;
    const customLabelConfig = get(master, 'config.custom_label_config') || {};
    const showCustomLabel = get(customLabelConfig, 'show_custom_label') || false;
    const showA6Option = get(master, 'config.allow_consignment_a6_print_label_request') || false;
    const customLabelOptions = get(customLabelConfig, 'custom_label_sizes') || [];
    const useCustomLabelOnly = get(customLabelConfig, 'use_custom_label_config_only') || false;
    if (customerProperties && enable_customer_config) {
        showShipmentLabelA4 = customerProperties?.a4_shipping_label;
        showShippingLabelA6 = customerProperties?.a6_shipping_label;
        showAddressLabelA4 = customerProperties?.a4_address_label;
        showAddressLabel4X2 = customerProperties?.x42_address_label;
        useThirdPartyLabel = customerProperties?.use_third_party_label;
    }

    const showShippingLabelButton = showShipmentLabelA4 || showShippingLabelA6;

    const loadData = async () => {
        setLoading(true);
        let response;
        if (softdataCreationUnifiedFlow) {
            let newPageNumber = pagination.currentPageNumber;
            if (pagination.nextOrPrev === 'next') {
                newPageNumber = pagination.currentPageNumber + 1;
            } else if (pagination.nextOrPrev === 'prev' && pagination.currentPageNumber > 1) {
                newPageNumber = pagination.currentPageNumber - 1;
            } else if (pagination.nextOrPrev === 'first') {
                newPageNumber = 1;
            }

            response = await getAsyncRequestsData({
                pageNumber: newPageNumber,
                fromDate: dates.startDate.format('YYYY-MM-DD'),
                toDate: dates.endDate.format('YYYY-MM-DD'),
                jobType: 'ASYNC_CONSIGNMENT_SOFTDATA_UPLOAD',
            });
            if (!response.isSuccess) {
                message.error(response.errorMessage || 'Something went wrong');
            } else {
                const jobRequests = response?.data?.page_data || [];
                setExcels(jobRequests.map((job: any) => ({
                    csvId: Helper.customFormatDate(job.createdAt, 'DDMMMYYYY_HHmmss', ''),
                    jobId: job.jobId,
                    numberOfConsignments: job.totalConsignmentCount || 0,
                    softDataSuccess: Number(job.successConsignmentCount) || 0,
                    softDataFailure: Number(job.failedConsignmentCount) || 0,
                    softDataPending: Number(job.onGoingConsignmentCount) || 0,
                    createdAt: job.createdAt,
                    status: job.status,
                    createdBy: job.creatorId || job.source,
                    creationSource: job.source,
                })));
                setPagination({
                    ...pagination,
                    currentPageNumber: newPageNumber,
                    isNextPresent: response?.data?.is_next_present || false,
                });
            }
        } else {
            response = await getExcels({
                startDate: dates.startDate.format('YYYY-MM-DD'),
                endDate: dates.endDate.format('YYYY-MM-DD'),
                currentPage: pagination.currentPageNumber,
                nextOrPrev: pagination.nextOrPrev,
                resultPerPage: pagination.resultPerPage,
                lastUpdatedAt: pagination.lastUpdatedAt,
            });

            if (response.isSuccess) {
                setExcels(response?.data?.csvUploaded || []);
                setPagination({
                    ...pagination,
                    currentPageNumber: response?.data?.currentPageNo,
                    isNextPresent: response?.data?.nextPageExist,
                });
            }
        }
        setLoading(false);
    };

    React.useEffect(() => {
        loadData();
    }, [dates, toggle]);

    const getDisabled = (current: Moment) => {
        return current && moment(current) >= moment();
    };

    const renderRangePicker = () => {
        return (
            <div className={classes.filter}>
                <DatePicker.RangePicker
                    value={[dates.startDate, dates.endDate]}
                    disabledDate={(current) => getDisabled(current)}
                    allowClear={false}
                    dropdownClassName={classes.dateRange}
                    placeholder={[t('From_date'), t('To_date')]}
                    onChange={(values) => {
                        setDates({
                            startDate: moment(values?.[0]),
                            endDate: moment(values?.[1]),
                        });
                        setPagination({
                            ...pagination,
                            nextOrPrev: 'first',
                            lastUpdatedAt: null,
                        });
                        setToggle(!toggle);
                    }}
                />
            </div>
        );
    };

    const handlePagination = (nextOrPrev: NextOrPrev) => {
        if (loading) return;
        const { currentPageNumber } = pagination;
        let newPageNumber = currentPageNumber;
        let newUpdatedAt = null;
        if (nextOrPrev === 'first') {
            newPageNumber = 1;
            newUpdatedAt = null;
        } else if (nextOrPrev === 'next') {
            const lastExcel = excels[excels.length - 1];
            newUpdatedAt = lastExcel.createdAt;
        } else {
            const firstExcel = excels[0];
            newUpdatedAt = firstExcel.createdAt;
        }
        const newPagination = {
            ...pagination,
            nextOrPrev,
            lastUpdatedAt: newUpdatedAt,
            currentPageNumber: newPageNumber,
        };
        setPagination(newPagination);
        setToggle(!toggle);
    };

    const renderRefresh = () => {
        return (
            <Tooltip title={t('reload')}>
                <Button
                    size="small"
                    type="ghost"
                    style={{
                        color: uiTheme.primaryColor,
                        fontSize: 14,
                        marginRight: 8,
                    }}
                    onClick={() => setToggle(!toggle)}
                >
                    <ReloadOutlined />
                </Button>
            </Tooltip>
        );
    };

    const renderText = (text: string) => {
        return (
            <div
                className={classes.cellValue}
            >
                {text}
            </div>
        );
    };

    const getDownloadLink = (feature: string, row: any) => {
        const headers = authHelper.getAuthenticationHeaders();
        const linkArray = [`${BUSINESS_BOOKING_API_URL}${feature}?`];
        linkArray.push(`csvId=${row.csvId}`);
        linkArray.push(`header-customer-user-id=${headers['customer-user-id']}`);
        linkArray.push(`header-access-token=${headers['access-token']}`);
        linkArray.push(`header-user-id=${headers['user-id']}`);
        linkArray.push(`header-organisation-id=${headers['organisation-id']}`);
        return linkArray.join('&');
    };

    const handleCNUploadRequests = async (jobId: string, requestType: string) => {
        let fileBuffer: any = {};
        const params = {
            job_id: jobId,
            type: requestType,
            job_type: 'ASYNC_CONSIGNMENT_SOFTDATA_UPLOAD',
        };
        fileBuffer = await getCNUploadRequests(params);
        if (fileBuffer.isSuccess) {
            // Parse filename from Content-Disposition header (format: "attachment;filename=filename.xlsx")
            let fileName = 'consignments_upload.xlsx';
            if (fileBuffer.filename) {
                const dispositionMatch = fileBuffer?.filename?.match(/filename=([^;]+)/);
                if (dispositionMatch && dispositionMatch?.[1]) {
                    fileName = dispositionMatch?.[1]?.replace(/["']/g, ''); // Remove quotes if present
                }
            }
            Helper.downloadBlobData(fileBuffer.data, fileName, true);
            message.success('Downloaded Completed');
        } else {
            message.error(fileBuffer.errorMessage);
        }
    };

    const renderDownloadOptions = (row: any) => {
        return (
            <Menu>
                <Menu.Item
                    style={menuStyle}
                >
                    <a href={getDownloadLink(EXCEL_DOWNLOAD, row)}>{t('download_data')}</a>
                </Menu.Item>
                <Menu.Item
                    style={menuStyle}
                >
                    <a href={getDownloadLink(EXCEL_DOWNLOAD_ERRORS, row)}>{t('download_errors')}</a>
                </Menu.Item>
                <Menu.Item
                    style={menuStyle}
                >
                    <a href={getDownloadLink(EXCEL_PENDING, row)}>{t('download_pending_softdata')}</a>
                </Menu.Item>
            </Menu>
        );
    };


    const renderDownloadOptionsNew = (row: any) => {
        return (
            <Menu>
                <Menu.Item
                    style={menuStyle}
                    onClick={() => handleCNUploadRequests(row.jobId, csvRequestType.totalConsignmentCount)}
                >
                    {t('download_data')}
                </Menu.Item>
                {row.softDataSuccess > 0 && (
                    <Menu.Item
                        style={menuStyle}
                        onClick={() => handleCNUploadRequests(row.jobId, csvRequestType.successConsignmentCount)}
                    >
                        {t('download_success')}
                    </Menu.Item>
                )}
                {row.softDataFailure > 0 && (
                    <Menu.Item
                        style={menuStyle}
                        onClick={() => handleCNUploadRequests(row.jobId, csvRequestType.failedConsignmentCount)}
                    >
                        {t('download_errors')}
                    </Menu.Item>
                )}
                {row.softDataPending > 0 && (
                    <Menu.Item
                        style={menuStyle}
                        onClick={() => handleCNUploadRequests(row.jobId, csvRequestType.onGoingConsignmentCount)}
                    >
                        {t('download_pending_softdata')}
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const handleResponse = (response: any) => {
        if (response.isSuccess) {
            message.success('Can download document from Print History -> Label');
            history.push(getPrintHistoryRoute());
        } else {
            message.error(response.errorMessage);
        }
    };

    const handlePrint = async (row: any, printType: string, isSmall = false) => {
        let fileBuffer;
        if (softdataCreationUnifiedFlow) {
            fileBuffer = await printBulkLabelWithPx({
                action_type: 'usequeue',
                job_id: row.jobId,
                label_type: printType,
                is_small: isSmall,
            });
        } else {
            fileBuffer = await printExcelA4({
                csvId: encodeURIComponent(row.csvId),
                printType,
                isSmall,
            });
        }
        handleResponse(fileBuffer);
    };

    const handleCustomLabelPrint = async (row: any, customLabelSize: string, printType: string) => {
        let fileBuffer;
        if (softdataCreationUnifiedFlow) {
            fileBuffer = await printBulkLabelWithPx({
                action_type: 'usequeue',
                job_id: row.jobId,
                label_type: printType,
                show_custom_label: true,
                custom_label_size: customLabelSize,
            });
        } else {
            fileBuffer = await printExcelA4({
                csvId: encodeURIComponent(row.csvId),
                printType,
                showCustomLabel: true,
                customLabelSize,
            });
        }
        handleResponse(fileBuffer);
    };

    const renderCustomLabelOptions = (row: any) => {
        const arr = [];
        if (showA6Option && !useCustomLabelOnly) {
            arr.push('a4', 'a6');
        }
        if (Array.isArray(customLabelOptions) && customLabelOptions.length) {
            customLabelOptions.forEach((elem) => {
                arr.push(elem);
            });
        }

        return arr.map((labelSize) => {
            return (
                <Menu.Item
                    style={{ padding: '5px 10px' }}
                    onClick={() => handleCustomLabelPrint(
                        row,
                        labelSize,
                        'Shipping_Label',
                    )}
                >
                    {labelSize}
                </Menu.Item>
            );
        });
    };

    const renderPrintOptions = (row: any) => {
        return (
            <Menu>
                {showShippingLabelButton && (
                    <Menu.SubMenu
                        title={(
                            <span
                                style={{
                                    ...menuStyle,
                                    padding: 0,
                                    border: 'none',
                                }}
                            >
                                {t('shipping_label')}
                            </span>
                        )}
                        style={{
                            ...menuStyle,
                            padding: 6,
                        }}
                    >
                        {showCustomLabel ? renderCustomLabelOptions(row) : null}
                        {!showCustomLabel && showShipmentLabelA4 && (
                            <Menu.Item
                                style={menuStyle}
                                onClick={() => handlePrint(row, 'Shipping_Label', false)}
                            >
                                {t('label_a4')}
                            </Menu.Item>
                        )}
                        {!showCustomLabel && showShippingLabelA6 && (
                            <Menu.Item
                                style={menuStyle}
                                onClick={() => handlePrint(row, 'Shipping_Label', true)}
                            >
                                {t('label_a6')}
                            </Menu.Item>
                        )}
                    </Menu.SubMenu>
                )}
                {showAddressLabel4X2 && (
                    <Menu.Item
                        style={menuStyle}
                        onClick={() => handlePrint(row, 'Address_Label_4*2')}
                    >
                        {t('address_label')}
                        4*2
                    </Menu.Item>
                )}
                {showAddressLabelA4 && (
                    <Menu.Item
                        style={menuStyle}
                        onClick={() => handlePrint(row, 'Address_Label_A4')}
                    >
                        {t('address_label')}
                        A4
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const renderColumn = (text: string, column: ExcelColumn, row: any) => {
        if (column.column_id === 'actions') {
            return (
                <div className={classes.row}>

                    {!useThirdPartyLabel ? (
                        <Dropdown
                            overlay={renderPrintOptions(row)}
                        >
                            <PrinterOutlined />
                        </Dropdown>
                    ) : null}
                    <Dropdown
                        overlay={softdataCreationUnifiedFlow ? renderDownloadOptionsNew(row) : renderDownloadOptions(row)}
                    >
                        <DownloadOutlined style={{ margin: '0 4px' }} />
                    </Dropdown>
                </div>
            );
        }
        if (column.column_id === 'isInternational') {
            let consignmentCategory = ConsignmentCategory.DOMESTIC;
            if (text) {
                consignmentCategory = ConsignmentCategory.INTERNATIONAL;
            }
            return renderText(consignmentCategory);
        }
        if (column.column_id === 'createdAt') {
            const date = text ? moment(text).format('DD/MM/YYYY, hh:mm:ss') : '-NA-';
            return renderText(date);
        }
        if (text === null) {
            return <div className={classes.cellNa}>-NA-</div>;
        }
        return renderText(text);
    };

    const getColumns = (): any[] => {
        /* eslint-disable no-nested-ternary */
        const columns: any = excelColumns.map((column: ExcelColumn) => {
            return {
                key: column.column_id,
                title: column.column_id === 'isInternational' ? t('consignment_category') : column.column_id === 'createdAt'
                    ? t('date_time') : t(column.column_id),
                dataIndex: column.column_id,
                ellipsis: true,
                bordered: false,
                width: column.width,
                render: (text: string, row: any) => renderColumn(text, column, row),
            };
        });
        return columns;
    };

    const renderTable = () => {
        return (
            <FixedHeaderTable
                bordered={false}
                pagination={false}
                loading={loading}
                rowKey={(row: any) => row.csvId}
                columns={getColumns()}
                dataSource={excels}
                rowSelection={{
                    onSelect: (row) => (row),
                    onSelectAll: (rows) => (rows),
                }}
                scroll={{
                    y: 'calc(100% - 115px)',
                }}
                style={{
                    height: 'calc(100% - 80px)',
                    background: '#ffffff',
                }}
            />
        );
    };

    const renderDateFilter = () => {
        return (
            <div className={classes.dateFilter}>
                {renderRangePicker()}
            </div>
        );
    };

    const renderFilters = () => {
        return (
            <div className={classes.filters}>
                {renderRefresh()}
                {renderDateFilter()}
            </div>
        );
    };

    const renderPaginator = () => {
        return (
            <div style={{ direction: 'ltr', display: 'flex' }}>
                <Paginator
                    currentPageNumber={pagination.currentPageNumber}
                    isNextPresent={pagination.isNextPresent}
                    onNextClick={() => handlePagination('next')}
                    onPrevClick={() => handlePagination('prev')}
                    onFirstClick={() => handlePagination('first')}
                />
            </div>
        );
    };

    const renderFooter = () => {
        return (
            <div className={classes.footer}>
                {renderPaginator()}
            </div>
        );
    };

    return (
        <div className={classes.main}>
            {renderFilters()}
            <>
                {renderTable()}
                {renderFooter()}
            </>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    const { master, uiTheme } = state;
    return {
        master,
        uiTheme,
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
    connectRouter: true,
    connectTranslession: true,
};

export default GenericHoc(hocConfig)(ExcelUpload);
